import type { ClientPageKey } from "../app/product-router.js";
import { ApprovedScene } from "./approved-scene.js";

export type BackgroundKey =
  | "clubhouse"
  | "clubhouse-dim"
  | "rivalry"
  | "feed"
  | "teeoff"
  | "fgl"
  | "plain";

const backgrounds: Record<ClientPageKey, BackgroundKey> = {
  clubhouse: "clubhouse",
  "tee-off": "teeoff",
  scorecard: "plain",
  rounds: "clubhouse-dim",
  rivals: "clubhouse-dim",
  rivalry: "rivalry",
  feed: "feed",
  courses: "clubhouse-dim",
  stats: "clubhouse-dim",
  insights: "clubhouse-dim",
  trophies: "clubhouse-dim",
  reviews: "clubhouse-dim",
  profile: "clubhouse-dim",
  settings: "clubhouse-dim",
  admin: "clubhouse-dim",
  fgl: "fgl",
  more: "plain",
};

export function backgroundFor(page: ClientPageKey): BackgroundKey {
  return backgrounds[page];
}

/** Fixed, full-bleed photographic background behind the current page. */
export function PageBackground({
  page,
}: {
  page: ClientPageKey;
}): React.JSX.Element {
  if (["clubhouse", "rivalry", "feed", "fgl"].includes(page))
    return <ApprovedScene page={page} />;
  if (["settings", "reviews", "admin"].includes(page))
    return <ApprovedScene page="settings" />;
  return <div className="fr-bg" data-bg={backgroundFor(page)} aria-hidden />;
}
